import CheckIcon from '@mui/icons-material/Check';
import { IconButton } from '@mui/material';
import React from 'react';
// import { useTranslation } from 'react-i18next';

const DoneButton = ({ onClick }: { onClick?: () => void }) => {
  // const { t } = useTranslation();
  return (
    <IconButton
      style={{ background: 'rgba(39, 174, 96, 0.12)', cursor: 'pointer' }}
      onClick={() => {
        onClick?.();
      }}
    >
      <CheckIcon style={{ color: '#27AE60' }} />
    </IconButton>
  );
};

export default DoneButton;
